<template>
  <div class="modal-drag-custom-drag" :class="$vuetify.breakpoint.mobile && 'mobile-popup'" :style="{ zIndex: indexModalIndex }">
		<modal
			name="custom_drag_modal"
			:style="{ zIndex: indexModalIndex }"
			hide-overlay
			draggable=".drag-header"
			:clickToClose="true"
			@before-close="closeModal"
			:focusTrap="true"
			:adaptive="true"
			height="auto"
		>
      <v-card>
        <v-card-title class="pa-0 drag-header">
					<div class="d-flex flex-row align-center justify-space-between py-2 px-8 w-100">
						<div class="d-flex flex-row align-center">
							<v-icon color="white" small class="info-icon mr-2">mdi-file-document-plus-outline</v-icon>
							<p class="mb-0 font-weight-bold text-primary title">Editor de Plantillas</p>
						</div>
						<v-btn class="mx-2" fab dark small color="#FF1209" @click="closeModal">
							<v-icon dark>mdi-close</v-icon>
						</v-btn>
					</div>
				</v-card-title>
        <v-card-text class="pa-0">
          <div class="py-4 px-8">
            <v-form ref="form" v-model="validform" class="mt-6">
              <v-row class="mb-4">
								<v-col cols="12" class="py-0">
									<v-text-field
										v-model="newReportTemplate.name"
										:rules="requiredRule"
										label="Nombre plantilla"
										solo
										flat
										hide-details
										dense
										outlined
									></v-text-field>
                </v-col>
								<v-col cols="12">
									<div v-if="loadingMce" class="d-flex flex-column justify-center align-center" style="min-height: 200px;">
										<v-skeleton-loader
											style="width: 250px;"
											class="mb-1"
											type="paragraph"
										></v-skeleton-loader>
										<p>Cargando editor...</p>
									</div>
									<vue2-tinymce-editor
										v-else
										:inline="true"
										v-model="newReportTemplate.content"
											:options="{
												plugins: 'paste image imagetools',
												language: 'es',
												language_url: 'https://cdn.tiny.cloud/1/no-api-key/tinymce/5/langs/es.js',
												font_formats: 'Archivo Narrow=system-ui; Andale Mono=andale mono,times; Arial=arial,helvetica,sans-serif; Arial Black=arial black,avant garde; Book Antiqua=book antiqua,palatino; Comic Sans MS=comic sans ms,sans-serif; Courier New=courier new,courier; Georgia=georgia,palatino; Helvetica=helvetica; Impact=impact,chicago; Symbol=symbol; Tahoma=tahoma,arial,helvetica,sans-serif; Terminal=terminal,monaco; Times New Roman=times new roman,times; Trebuchet MS=trebuchet ms,geneva; Verdana=verdana,geneva; Webdings=webdings; Wingdings=wingdings,zapf dingbats',
												toolbar: 'undo redo | fontselect fontsizeselect addVariableButton | styleselect bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | table',
												content_style: `
													@import url('https://fonts.googleapis.com/css2?family=Archivo+Narrow:ital,wght@0,400..700;1,400..700&display=swap');
													body { font-size: 10pt; font-family: Archivo Narrow; }
												`,
												content_css: `
													.friendly-placeholder {
														color: #007bff;
														background-color: #e9f7ff;
														padding: 2px 4px;
														border-radius: 4px;
														font-style: italic;
													}
												`,
												automatic_uploads:true,
												images_upload_handler: uploadImageFromTiny,
												file_picker_callback: filePickerTiny
											}"
											ref="tinymceEditor"></vue2-tinymce-editor>
								</v-col>
              </v-row>

              <v-row align="center">
                <v-col cols="12">
                  <div class="d-flex flex-row justify-end">
                    <v-btn
                      class="mx-2 my-1"
                      color="white"
                      raised
                      @click="closeModal"
                    >
                      <p class="mb-0 text-primary">Cancelar</p>
                    </v-btn>
										<v-btn
											depressed
											color="#524D4D"
											:dark="!(!newReportTemplate.name || newReportTemplate.name.length == 0)"
											small
											outlined
											:loading="loading"
											class="ml-2"
											style="height: 40px"
											:disabled="!newReportTemplate.name || newReportTemplate.name.length == 0"
											@click="saveReportTemplate()"
										>
											<v-icon small>mdi-send</v-icon>
											<p class="mb-0 ml-2 caption">Guardar Plantilla</p>
										</v-btn>
                  </div>
                </v-col>
              </v-row>
            </v-form>
          </div>
        </v-card-text>
      </v-card>
    </modal>
  </div>
</template>

<script>
import { Vue2TinymceEditor } from "vue2-tinymce-editor"
import {createVTReportTemplate, updateVTReportTemplate} from '@/helpers/api/vts'
import {fileUploadToReport} from '@/helpers/api/files'

export default {
  name: 'NewUserModal',
  components: {
    Vue2TinymceEditor
  },
  data: () => ({
		indexModal: + new Date(),
    validform: true,
		loadingMce: true,
		newReportTemplate: {
			id: null,
			content: '',
			name: null
		},
    requiredRule: [
      v => !!v || 'Campo requerido'
    ],
		loading: false,
    emailRules: [
      v => !!v || 'Email es obligatorio',
      v => /.+@.+\..+/.test(v) || 'Email debe ser válido',
    ]
  }),
  computed: {
		indexModalIndex(){
			const ordered = [...this.$store.state.general.openModalOrders].sort((a, b) => a - b)
			return ordered.indexOf(this.indexModal) + 10
		},
		selectedCompany(){
			return this.$store.state.companies.selectedCompany
		}
	},
  mounted(){
		if(this.$store.state.vt.newReportTemplateEditing){
			this.newReportTemplate = this.$store.state.vt.newReportTemplateEditing
		}
		this.$modal.show('custom_drag_modal')
			this.$store.commit('general/addOpenModalOrders', this.indexModal)
		this.$nextTick(() => {
				this.loadingMce = false
		});
  },
  methods: {
		async saveReportTemplate(){
      if(this.$refs.form.validate()){
				const data = { ...this.newReportTemplate, ...{template_id: this.newReportTemplate.id}}
				const report = this.newReportTemplate.id ? await updateVTReportTemplate(data):await createVTReportTemplate(data)
				if(report.code == 200){
					this.$store.dispatch('vt/getVtReportTemplates')
					const data = {
						message: this.newReportTemplate.id  ? 'Actualización realizada correctamente.':'Creación realizada correctamente',
						title: 'Ok',
						created: new Date(),
						type: 'success',
						icon: 'mdi-check-circle',
						color: '#3EBFA3'
					}
					this.$store.dispatch('general/addMessage', data)
					this.closeModal()
				}
				else{
					const data = {
						message: 'Por favor intenta nuevamente.',
						title: 'Error',
						created: new Date(),
						type: 'danger',
						icon: 'mdi-close-octagon',
						color: '#FF1209',
					}
					this.$store.dispatch('general/addMessage', data)
				}
			}
		},
		uploadImageFromTiny(file, succes, failure){
			const formData = new FormData();
			formData.append('file', file.blob());

			fileUploadToReport(formData)
				.then((uploaded_file) => {
					if (uploaded_file.code === 200) {
						succes(uploaded_file.url);
					} else {
						failure(new Error(`Error: ${uploaded_file.code}`));
					}
				})
				.catch((error) => {
					failure(error);
				});
		},
		filePickerTiny(callback) {
			const input = this.$refs.fileInput;
			input.onchange = async (event) => {
				const file = event.target.files[0];
				const formData = new FormData();
				formData.append('file', file);
				try {
					const uploaded_file = await fileUploadToReport(formData);
					if (uploaded_file.code === 200) {
						const url = uploaded_file.url;
						callback(url, { alt: file.name });
					} else {
						console.error('Error al subir la imagen:', uploaded_file.message);
					}
				} catch (error) {
					console.error('Error en la subida de la imagen:', error);
				}
			};
			input.click();
		},
    closeModal(){
      this.$store.commit('vt/setNewReportTemplateModal', false)
			this.$store.commit('vt/setNewReportTemplateEditing', null)
      this.newReportTemplate = {
				id: null,
				content: '',
				name: null
			}
			this.loadingMce = true
      this.validform = true
      this.loadingData = false
    }
  }
};
</script>

<style scoped>
	.profile-avatar{
		cursor: pointer;
	}
  .info-container{
    color: #606060;
  }
  .text-primary{
    color: #524D4D;
  }
  .info-icon{
    background-color: #524D4D;
    border-radius: 25px;
    padding: 3px;
    width: 35px;
    height: 35px;
  }
  .info-icon.small-icon{
    width: 25px;
    height: 25px;
  }
  .info-img{
    width: 100%;
    max-height: 50px;
    object-fit: contain;
  }
  .adjuntos-container{
    background-color: #EFEFEF;
    max-height: 95px;
    overflow-y: scroll;
  }
  .interaction-container{
    width: 100%;
    background-color: #E5E9F2;
    border-radius: 5px;
    position: relative;
    padding: 12px;
  }
  .user-avatar.small{
    width: 25px;
    height: 25px;
  }
  .light-blue-text{color: #959595;}
  .interaction-container .icon-arrow{
    font-size: 80px;
    position: absolute;
    top: 20px;
    line-height: inherit;
  }
  .interaction-container.right .icon-arrow{
    left: -46px;
  }
  .interaction-container.left .icon-arrow{
    right: -46px;
  }
  /deep/ .custom-input-numbers .v-input__slot{padding:0!important;}
  /deep/ .custom-input-numbers .v-input__prepend-inner,
  /deep/ .custom-input-numbers .v-input__append-inner,
  /deep/ .custom-text-input .v-input__append-inner{margin-top:0!important;}
  /deep/ .custom-input-numbers input {text-align: center }
</style>